$shm_hitalama_text_rows $mol_list
	render_visible_only false
